import type { Capability } from "../../services/viewer";

/**
 * The dashboard's top-level destinations.
 *
 * There was no nav structure at all before this: the Navbar held a logo and a
 * login button, and every other move was a breadcrumb or a template-string
 * `navigate()` from inside the insights pages. This is the minimum needed to show
 * one more section without inventing a navigation system.
 *
 * `requires` hides an item the viewer cannot use. Hiding is presentation -- the
 * route is still reachable by typing the URL, and the server refuses the calls
 * behind it either way.
 */
export type NavItem = {
  to: string;
  label: string;
  /** Hidden unless the viewer holds this capability. */
  requires?: Capability;
  /** Also highlighted for child routes, e.g. /admin/people/:id. */
  matchPrefix?: string;
  /**
   * Exact paths that also count as this section.
   *
   * For routes that render the same component under a second path, where a
   * prefix would be wrong: "/" is not a prefix of anything useful.
   */
  alsoActiveAt?: string[];
};

export const NAV_ITEMS: NavItem[] = [
  {
    to: "/insights",
    label: "Insights",
    matchPrefix: "/insights",
    // "/" renders InsightsLayout too (App.js), and it is where everyone lands
    // after signing in -- so without this the most-visited page in the product
    // highlights no tab at all.
    alsoActiveAt: ["/"],
  },
  {
    to: "/admin/people",
    label: "People",
    requires: "ManagePeople",
    matchPrefix: "/admin",
  },
];
